// extracted by mini-css-extract-plugin
export default {"pokerInfo":"PokerInfo_pokerInfo__iZAgl"};